/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RemoteActionJobDetails } from './RemoteActionJobDetails';
import type { RemoteActionJobDeviceGroup } from './RemoteActionJobDeviceGroup';
import type { RemoteActionJobParameters } from './RemoteActionJobParameters';
export type RemoteActionJobResponseDto = {
  id: number;
  /**
   * unique UUID identifier
   */
  name: string;
  action: RemoteActionJobResponseDto.action;
  status: RemoteActionJobResponseDto.status;
  parameters?: RemoteActionJobParameters;
  details?: RemoteActionJobDetails;
  groups?: Array<RemoteActionJobDeviceGroup>;
  createdBy: string;
  updatedAt: string;
  createdAt: string;
};
export namespace RemoteActionJobResponseDto {
  export enum action {
    REBOOT = 'REBOOT',
    LOG_REQUEST = 'LOG_REQUEST',
    FIRMWARE_UPDATE = 'FIRMWARE_UPDATE',
    COMMAND = 'COMMAND',
  }
  export enum status {
    QUEUED = 'QUEUED',
    IN_PROGRESS = 'IN_PROGRESS',
    CANCELED = 'CANCELED',
    CANCELLATION_IN_PROGRESS = 'CANCELLATION_IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    DELETED = 'DELETED',
    DELETION_IN_PROGRESS = 'DELETION_IN_PROGRESS',
  }
}

